import { mappings as quickFactMappings } from '@nerdwallet/react-quick-facts';
export default (function (_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  return {
    drivers: [quickFactMappings.investing.getQuickFactFees(marketplaceEntity), quickFactMappings.investing.getQuickFactAccountMinimum(marketplaceEntity), quickFactMappings.investing.getQuickFactPromotion(marketplaceEntity)]
  };
});